module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.099b38ef.jpeg";